import React from "react";
// import { Link } from "react-router-dom";

import { Creatives } from "reducers/Creatives";
import FilterHeader from "utils/columns/FilterHeader";

import StatusColumn           from "../cells/StatusColumn";
import ExpandSizeColumn       from "../cells/ExpandSizeColumn";
import EmptyDashCell          from "../cells/EmptyDash";
import Decisioning            from "../cells/Decisioning";
import TotalFileSizeCell      from "../cells/TotalFileSizeColumn";
import CreativeActionsCell    from "../cells/CreativeActions";
import DateCell               from "../cells/DateColumn";
import BasicCheck             from "../cells/BasicCheck";
import NumClickTags           from "../cells/NumClickTags";
import CreativeName           from "../cells/CreativeName";
import SelectCell             from "../cells/SelectCell";
import SelectAllCreativesCell from "../cells/SelectAllCreativesCell";
import FileNameCell           from "../cells/FileName";
import AdTypeCell             from "../cells/AdType";
import SelectExistingCell     from '../cells/SelectCellExisting';
import NumVersionsCell        from "../cells/NumVersions";
import CreativeLabels         from "../cells/CreativeLabels";

import { GRID_TYPE } from "../constants";
import { formatBytes, isSocialCreative, isIncomplete, TextOverflow, KILO } from "utils/common";
import { buildSelectedDimensionsList } from "widgets/modals/creatives/open/ExistingCreativesGrid";

const CREATIVE = "kenobi";
function genRowId(data, str){
	return `${str}-${data}`;
}
export function genCreativeNameRowId(id) {
	return genRowId(id, CREATIVE);
}

export const SELECT_CELL = 	{
	...SelectCell,
	// locked: false,
	headerRenderer: () => <SelectAllCreativesCell />,
	getRowMetaData(data){
		return {
			type:"creatives",
			checkboxId:genRowId(data.id, CREATIVE),
			id:data.id,
			isSelected: data.isSelected || false,
		};
	},
};

const CREATIVE_NAME = {
	key: "name",
	name: "Creative Name",
	cellClass:"link-cell fill-cell",
	width:350,
	sortable:true,
	resizable:true,
	locked: true,
	getRowMetaData(data){
		return {
			checkboxId:genRowId(data.id, CREATIVE),
			creativeId: data.id,
			libraryId:  data.creativeLibraryId,
			adType:     data.adType,
			approval:   data.approval,
			shouldShowVersion:!/n|s/gi.test(data.instantAdType),
			isSocialCreative:isSocialCreative(data),
			isIncomplete:isIncomplete(data),
			type: "creatives",
			closedCaptions: data.closedCaptions || [],
		};
	},
	formatter:CreativeName,
};

const CREATIVE_ID = {
	key: "id",
	name: "ID",
	width:85,
	sortable:true,
	resizable:false,
	locked: true,
};

const CREATIVE_STATUS = {
	key: "approval",
	name: "Status",
	formatter:StatusColumn,
	resizable:true,
	sortable:true,
	width:130,
	locked: true,
	filter:"Checkbox",
	headerRenderer: (
		<FilterHeader
			Reducer = {Creatives}
			filterSelector = {state => state.creatives.columnFilters.active.approval}
		/>
	),
	getRowMetaData(data){
		return {
			libraryId:  data.creativeLibraryId,
			creativeId:	data.id,
			adType:     data.adType,
			origin:     data.origin,
		};
	},
};

const CREATIVE_VERSIONS = {
	...NumVersionsCell,
	key: "numberOfVersions",
	filter:"Range",
	headerRenderer: (
		<FilterHeader
			Reducer = {Creatives}
			filterSelector = {state => state.creatives.columnFilters.active.numberOfVersions}
		/>
	),
	getRowMetaData(data){
		return {
			creativeId: data.id,
		};
	},
	name: "Versions",
};

const CREATIVE_DECISIONING = {
	key:"decisioningType",
	name:"Decisioning",
	filter:"Checkbox",
	formatter:Decisioning,
	headerRenderer: (
		<FilterHeader
			Reducer = {Creatives}
			filterSelector = {state => state.creatives.columnFilters.active.decisioningType}
		/>
	),
	getRowMetaData(data){
		return{
			decisioningName:data.decisioningName,
		};
	},
	width:243,
	sortable:true,
	resizable:true,
};

const CREATIVE_TYPE = {
	key: "adType",
	name: "Type",
	filter:"Checkbox",
	formatter: AdTypeCell,
	headerRenderer: (
		<FilterHeader
			Reducer = {Creatives}
			filterSelector = {state => state.creatives.columnFilters.active.adType}
		/>
	),
	width:180,
	sortable:true,
	resizable:true,
};

const CREATIVE_DIMENSIONS = {
	key: "placementSize",
	name: "Dimensions",
	filter:"Checkbox",
	headerRenderer: (
		<FilterHeader
			Reducer = {Creatives}
			filterSelector = {state => state.creatives.columnFilters.active.placementSize}
		/>
	),
	width:135,
	sortable:true,
	resizable:true,
};

const CREATIVE_EXPAND_SIZE = {
	key: "expandedSize",
	name: "Expand Size",
	filter:"Checkbox",
	formatter:ExpandSizeColumn,
	headerRenderer: (
		<FilterHeader
			Reducer = {Creatives}
			filterSelector = {state => state.creatives.columnFilters.active.expandedSize}
		/>
	),
	getRowMetaData(data){
		return {
			expandedWidth:data.expandedWidth,
			expandedHeight:data.expandedHeight,
			unExpandedWidth:data.unExpandedWidth,
		};
	},
	width:110,
	sortable:true,
	resizable:true,
};

const CREATIVE_BASE_SIZE = {
	key: "filesize",
	name: "Base File Size",
	filter:"Range",
	headerRenderer: (
		<FilterHeader
			Reducer = {Creatives}
			filterSelector = {state => state.creatives.columnFilters.active.filesize}
		/>
	),
	width:120,
	formatter({ value, dependentValues }){
		if(isSocialCreative(dependentValues)){
			return () => <EmptyDashCell />;
		}

		return formatBytes(value, 1);
	},
	getRowMetaData(data){
		return { adType:data.adType };
	},
	sortable:true,
	resizable:true,
};

const CREATIVE_TOTAL_SIZE = {
	...TotalFileSizeCell,
	name: "Total Filesize",
	key: "totalFileSize",
	filter:"Range",
	headerRenderer: (
		<FilterHeader
			Reducer = {Creatives}
			filterSelector = {state => state.creatives.columnFilters.active.totalFileSize}
		/>
	),
	getRowMetaData(data){
		let { origin, totalFileSize, adType } = data
			, isNA = false;

		if(origin && origin === "adstudio"){
			if(!totalFileSize || totalFileSize === 0){
				isNA = true;
			}
		}

		return {
			isNA,
			adType,
			type: GRID_TYPE.CREATIVE,
			sizeLimitSelector: (state => (state.libraryProperties?.contentLimitInKilobytes * KILO || 0)),
			shouldShowWarning: !(/preroll/gi.test(adType) || /vastaudio/gi.test(adType)),
		};
	},
};

const CREATIVE_LABELS = {
	name: "Creative Labels",
	key: "labelsCnt",
	filter: "Range",
	width: 130,
	sortable: true,
	resizable: true,
	formatter: CreativeLabels,
	headerRenderer: (
		<FilterHeader
			Reducer = {Creatives}
			filterSelector = {state => state.creatives.columnFilters.active.labelsCnt}
		/>
	),
	getRowMetaData(data){
		return {
			creativeId: data.id,
			libraryId: data.creativeLibraryId,
			isSocialCreative: isSocialCreative(data),
		};
	},
};

const CREATIVE_AUTO_CLASSIFICATION_STATUS = {
	key: "autoClassificationStatus",
	name: "Auto-classification Status",
	filter: "Checkbox",
	width: 185,
	sortable: true,
	resizable: true,
	headerRenderer: (
		<FilterHeader
			Reducer = {Creatives}
			filterSelector = {state => state.creatives.columnFilters.active.autoClassificationStatus}
		/>
	),
};

const CREATIVE_CLICK_TAGS = {
	key: "numClickTags",
	name: "# ClickTags",
	filter:"Checkbox",
	headerRenderer: (
		<FilterHeader
			Reducer = {Creatives}
			filterSelector = {state => state.creatives.columnFilters.active.numClickTags}
		/>
	),
	width:110,
	formatter:NumClickTags,
	sortable:true,
	resizable:true,
};

const CREATIVE_IS_VIDEO = {
	key: "isVideo",
	name: "Video",
	filter:"Checkbox",
	formatter:BasicCheck,
	headerRenderer: (
		<FilterHeader
			Reducer = {Creatives}
			filterSelector = {state => state.creatives.columnFilters.active.isVideo}
		/>
	),
};

const CREATIVE_IS_RICHLOAD = {
	key: "isRichload",
	name: "Richload",
	filter:"Checkbox",
	formatter:BasicCheck,
	headerRenderer: (
		<FilterHeader
			Reducer = {Creatives}
			filterSelector = {state => state.creatives.columnFilters.active.isRichload}
		/>
	),
	width:100,
	sortable:true,
	resizable:true,
};

const CREATIVE_API_VERSION = {
	key: "asComponentVersion",
	name: "API Version",
	filter:"Checkbox",
	headerRenderer: (
		<FilterHeader
			Reducer = {Creatives}
			filterSelector = {state => state.creatives.columnFilters.active.asComponentVersion}
		/>
	),
	width:110,
	sortable:true,
	resizable:true,
};

const CREATIVE_LAST_MODIFIED = {
	...DateCell,
	key: "lastModified",
	name: "Last Modified",
	width:200,
	filter:"Date",
	headerRenderer: (
		<FilterHeader
			Reducer = {Creatives}
			filterSelector = {state => state.creatives.columnFilters.active.lastModified}
		/>
	),
};

const CREATIVE_CONCEPT_NAME = {
	...EmptyDashCell,
	key: "conceptName",
	name: "Concept Name",
	filter:"String",
	width:200,
	formatter: TextOverflow,
	headerRenderer: (
		<FilterHeader
			Reducer = {Creatives}
			filterSelector = { state => state.creatives.columnFilters.active.conceptName}
		/>
	),
};

export const CREATIVE_COLUMNS = [
	SELECT_CELL
	, CREATIVE_NAME
	, CREATIVE_ID
	, CREATIVE_STATUS
	, CreativeActionsCell
	, CREATIVE_CONCEPT_NAME
	, CREATIVE_VERSIONS
	, CREATIVE_DECISIONING
	, CREATIVE_TYPE
	, CREATIVE_DIMENSIONS
	, CREATIVE_EXPAND_SIZE
	, CREATIVE_TOTAL_SIZE
	, CREATIVE_LABELS
	, CREATIVE_AUTO_CLASSIFICATION_STATUS
	, CREATIVE_BASE_SIZE
	, CREATIVE_CLICK_TAGS
	, CREATIVE_IS_VIDEO
	, CREATIVE_IS_RICHLOAD
	, CREATIVE_API_VERSION
	, FileNameCell
	, CREATIVE_LAST_MODIFIED
];

function buildSelectedList(start, end, items, currentSelection) {
	const selectedDimensions = buildSelectedDimensionsList(items, currentSelection)
		, selectedExistingCreatives = new Set(currentSelection);

	for(let i = start; i <= end; i++){
		const { id, width, height } = items[i] || {}
			, dimensions = `${width}x${height}`;

		if(!selectedDimensions.has(dimensions)){
			selectedExistingCreatives.add(id);
			selectedDimensions.add(dimensions);
		}
	}
	return [...selectedExistingCreatives];
}

export const EXISTING_CREATIVES_GRID_COLUMNS = [
	{
		...SelectExistingCell,
		locked: false,
		getRowMetaData(data){
			return {
				type:"existingCreatives",
				checkboxId:genRowId(data.id, CREATIVE),
				id:data.id,
				isSelected: data.isSelected || false,
				canSelect: data.canSelect,
				shiftSelectConfig: {
					buildSelectedList,
				},
			};
		},
	 }
	, {
		...CREATIVE_NAME,
		 locked: false,
	 }
	, {
		...CREATIVE_ID,
		locked: false,
	}
	, {
		...CREATIVE_STATUS,
		locked: false,
		headerRenderer: null,
	 }
	, {
		...CREATIVE_VERSIONS,
		headerRenderer: null,
	}
	, {
		...CREATIVE_DECISIONING,
		headerRenderer: null,
	}
	, {
		...CREATIVE_TYPE,
		headerRenderer: null,
	 }
	, {
		...CREATIVE_DIMENSIONS,
		headerRenderer:null,
	 }
	, {
		...CREATIVE_EXPAND_SIZE,
		headerRenderer:null,
	}
	, {
		...CREATIVE_BASE_SIZE,
		headerRenderer:null,
	}
	, {
		...CREATIVE_TOTAL_SIZE,
		headerRenderer:null,
	}
	, {
		...CREATIVE_CLICK_TAGS,
		headerRenderer:null,
	}
];
